 // 储存
 export function setCookie(cname, cvalue, exdays) {
   let d = new Date();
   d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
   let expires = 'expires' + d.toUTCString();
   document.cookie = cname + '=' + cvalue + ';' + expires;
 }
 // 获取
 export function getCookie(cname) {
   let name = cname + '=';
   let ca = document.cookie.split(';');
   for (var i = 0; i < ca.length; i++) {
     let c = ca[i].trim();
     if (c.indexOf(name) == 0) {
       return c.substring(name.length, c.length);
     }
   }
   return ""
 }
 // 检查
 export function checkCookie(cookieName) {
   var user = getCookie(cookieName);
   if (user != "") {
     return true
   } else {
     return false
   }
 }
 //删除cookie
 export function delCookie(name) {
   for (let i = 0; i < name.length; i++) {
     var exp = new Date();
     exp.setTime(exp.getTime() - 1);
     var cval = getCookie(name[i]);
     if (cval != null)
       document.cookie = name[i] + "=" + cval + ";expires=" + exp.toGMTString();
   }

 }
